import { render, staticRenderFns } from "./EditarClienteProveedorModal.vue?vue&type=template&id=337b9b4f&"
import script from "./EditarClienteProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./EditarClienteProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('337b9b4f', component.options)
    } else {
      api.reload('337b9b4f', component.options)
    }
    module.hot.accept("./EditarClienteProveedorModal.vue?vue&type=template&id=337b9b4f&", function () {
      api.rerender('337b9b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/EditarClienteProveedorModal.vue"
export default component.exports